import {
    ColumnStructure,
    ColumnsStructure
} from '../types/ColumnStructureItem';
import { sortCitiesByName } from './sortCitiesByName';

export const buildColumnStructure = (list: ColumnStructure, columlCount: number): ColumnsStructure => {
    const sortedList = sortCitiesByName(list);
    let columnNum = 0;
    const preparedStructure: ColumnsStructure = [];

    for(const item of sortedList){
        const currentColumnData = preparedStructure[columnNum] ?? [];
        currentColumnData.push(item);

        preparedStructure[columnNum] = currentColumnData;

        if(columnNum === (columlCount - 1)){
            columnNum = 0;
        } else {
            columnNum++;
        }
    }

    return preparedStructure;
}
